// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-91ee8556] .v-dialog {\n  overflow-x: hidden !important;\n}\n.col-4[data-v-91ee8556] {\n  max-width: 31.6% !important;\n}\n", ""]);
// Exports
module.exports = exports;
